/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Escrow_Hold_TitleInputs */

const en_rental_escrow_hold_title = /** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funds Held Securely`)
};

const es_rental_escrow_hold_title = /** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondos Retenidos de Forma Segura`)
};

const fr_rental_escrow_hold_title = /** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonds conservés en toute sécurité`)
};

const de_rental_escrow_hold_title = /** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geld sicher aufbewahrt`)
};

const id_rental_escrow_hold_title = /** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dana Disimpan dengan Aman`)
};

/** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */
const ja_rental_escrow_hold_title = en_rental_escrow_hold_title;

/** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */
const zh_rental_escrow_hold_title = en_rental_escrow_hold_title;

/** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */
const ar_rental_escrow_hold_title = en_rental_escrow_hold_title;

/** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */
const it_rental_escrow_hold_title = en_rental_escrow_hold_title;

/** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */
const ru_rental_escrow_hold_title = en_rental_escrow_hold_title;

/** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */
const pt_rental_escrow_hold_title = en_rental_escrow_hold_title;

/** @type {(inputs: Rental_Escrow_Hold_TitleInputs) => LocalizedString} */
const ko_rental_escrow_hold_title = en_rental_escrow_hold_title;

/**
* | output |
* | --- |
* | "Funds Held Securely" |
*
* @param {Rental_Escrow_Hold_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_escrow_hold_title = /** @type {((inputs?: Rental_Escrow_Hold_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Escrow_Hold_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_escrow_hold_title(inputs)
	if (locale === "es") return es_rental_escrow_hold_title(inputs)
	if (locale === "fr") return fr_rental_escrow_hold_title(inputs)
	if (locale === "de") return de_rental_escrow_hold_title(inputs)
	if (locale === "ja") return ja_rental_escrow_hold_title(inputs)
	if (locale === "zh") return zh_rental_escrow_hold_title(inputs)
	if (locale === "ar") return ar_rental_escrow_hold_title(inputs)
	if (locale === "id") return id_rental_escrow_hold_title(inputs)
	if (locale === "it") return it_rental_escrow_hold_title(inputs)
	if (locale === "ru") return ru_rental_escrow_hold_title(inputs)
	if (locale === "pt") return pt_rental_escrow_hold_title(inputs)
	return ko_rental_escrow_hold_title(inputs)
});